module.exports = __webpack_public_path__ + "static/media/mobile-bg.d1b5fca6.jpg";